import { render, staticRenderFns } from "./CheckAllPax.vue?vue&type=template&id=1dbc0eac&scoped=true"
import script from "./CheckAllPax.vue?vue&type=script&lang=js"
export * from "./CheckAllPax.vue?vue&type=script&lang=js"
import style0 from "./CheckAllPax.vue?vue&type=style&index=0&id=1dbc0eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbc0eac",
  null
  
)

export default component.exports